import React, {useContext, useEffect, useState} from 'react';
import {AccordionItem} from './components/AccordionItem';
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {ProductContext} from "../../../../pages/ProductStencil";
import {getDocList} from '../../../../../api/ECOM/getDocList.api';
import {Specifications} from "./components/Specifications";
import {Ingredients} from "./components/Ingredients";
import {DocGetListItem} from "../../../../../interfaces/ecom/schema";
import {isTDSDocType} from "./common";
import {Applications} from "./components/Applications";
import {Benefits} from "./components/Benefits";
import {AccordionSkeleton} from "../../../../atoms/effects/skeletons/product-stencil/AccordionSkeleton";
import { ContactUs } from './components/ContactUs';

export const Accordion: React.FC = () => {
    const translate = useI18N();
    const {product, SapDetails} = useContext(ProductContext);
    const [downloads, setDownloads] = useState<DocGetListItem[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const authorContent = product.ingredientsAllergensUsage;
    const [isIngredientsOpenByDefault, setIsIngredientsOpenByDefault] = useState(false);


    useEffect(() => {
        (async () => {
            try {
                if (isDataLoading) {
                    const {DocGetListItems} = (product.id && SapDetails?.length) ? await getDocList(product.id) : {DocGetListItems: null};
                    if (DocGetListItems) {
                        setDownloads(DocGetListItems);
                    }
                }
                setIsDataLoading(false);
            } catch (error) {
                setIsDataLoading(false);
                console.error(error);
            }
        })()
    },[]);

    useEffect(() => {
        if (!downloads.length) {return;}

        setIsIngredientsOpenByDefault(isTDSDocType(downloads) || (!!downloads.length && !authorContent))
    }, [downloads, authorContent]);

    const items = [
        {
            label: translate('Applications'),
            content: <Applications/>,
            openByDefault: true
        },
        {
            label: translate('Ingredients, Allergens, Usage and Downloads'),
            content: <Ingredients downloads={downloads}/>,
            openByDefault: isIngredientsOpenByDefault,
        },
        {
            label: translate('Specifications'),
            content: <Specifications/>,
            openByDefault: true
        },
        {
            label: translate(product.additionalAccordionLabel),
            content: <div className={!!product.additionalAccordionContent === false && "no-data"} dangerouslySetInnerHTML={{__html: product.additionalAccordionContent}}/>,
            openByDefault: false
        },
    ];

    if (isDataLoading) {
        return <AccordionSkeleton/>;
    }

    return (
        <div className="accordion">
            <Benefits/>
            {items.map(({label, content, openByDefault}, index) => (
                <AccordionItem openByDefault={openByDefault} key={index}
                               label={label}>{content}</AccordionItem>
            ))}
            <ContactUs/>
        </div>
    );
};
